import React from "react";
import withContentFallback from "../../utils/withContentFallback";
import { highlightsContent } from "../../constants/homePageContent";
import "./Highlights.css";

const Highlights = ({ content }) => {
  // No need for manual fallback, content already processed by HOC
  const { heading, items, foundingYear } = content;

  // Calculate years since founding year
  const currentYear = new Date().getFullYear();
  const yearsInBusiness = currentYear - foundingYear;

  return (
    <section className="highlights-section section animate-on-scroll">
      <div className="container">
        <h2 className="section-title">{heading}</h2>
        <div className="highlights-grid">
          {items &&
            items.map((item, index) => (
              <div className="highlight-card" key={index}>
                <div className="highlight-icon">{item.icon}</div>
                <h3>
                  {item.showYears
                    ? `${yearsInBusiness} ${item.title}`
                    : item.title}
                </h3>
                <p>
                  {item.showYears
                    ? item.text.replace("1930", foundingYear)
                    : item.text}
                </p>
              </div>
            ))}
        </div>
      </div>
    </section>
  );
};

// Wrap the component with withContentFallback HOC
export default withContentFallback(Highlights, highlightsContent);
